import { translation, TranslatedComponent } from '@hh.ru/front-static-app';
import { SPALink } from '@hh.ru/redux-spa-middleware';
import Column from 'bloko/blocks/column';
import Text, { TextImportance } from 'bloko/blocks/text';

const TrlKeys = {
    waitingForResume: 'applicantServices.order.resumeAudit.forResume',
    resumeWasDeleted: 'applicantServices.order.resume.was_deleted',
};

const ForResume: TranslatedComponent<{ hash?: string; name?: string }> = ({ hash, name, trls }) => {
    return (
        <>
            <Column xs="4" s="8" m="5" l="5" container>
                <Text importance={TextImportance.Secondary}>{trls[TrlKeys.waitingForResume]}</Text>
            </Column>
            <Column xs="4" s="8" m="4" l="4" container>
                {hash && name ? (
                    <SPALink to={`/resume/${hash}`} target="_blank">
                        {name}
                    </SPALink>
                ) : (
                    `[${trls[TrlKeys.resumeWasDeleted]}]`
                )}
            </Column>
        </>
    );
};

export default translation(ForResume);
